"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOP_DICTATE = void 0;
exports["default"] = stopDictate;
var STOP_DICTATE = 'WEB_CHAT/STOP_DICTATE';
exports.STOP_DICTATE = STOP_DICTATE;
function stopDictate() {
  return {
    type: STOP_DICTATE
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVE9QX0RJQ1RBVEUiLCJleHBvcnRzIiwic3RvcERpY3RhdGUiLCJ0eXBlIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc3RvcERpY3RhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1RPUF9ESUNUQVRFID0gJ1dFQl9DSEFUL1NUT1BfRElDVEFURSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN0b3BEaWN0YXRlKCkge1xuICByZXR1cm4geyB0eXBlOiBTVE9QX0RJQ1RBVEUgfTtcbn1cblxuZXhwb3J0IHsgU1RPUF9ESUNUQVRFIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxZQUFZLEdBQUcsdUJBQXVCO0FBQUNDLE9BQUEsQ0FBQUQsWUFBQSxHQUFBQSxZQUFBO0FBRTlCLFNBQVNFLFdBQVdBLENBQUEsRUFBRztFQUNwQyxPQUFPO0lBQUVDLElBQUksRUFBRUg7RUFBYSxDQUFDO0FBQy9CIn0=